import React, { Component } from 'react';
import Chart from 'react-apexcharts';


const breakpoint = 991;

class LineBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            avrNum : this.props.avrNum || 500000,
            AvrCPM : this.props.AvrCPM || 1.25,
            AdUnitsPP : this.props.AdUnitsPP || 3,
            withPublift : 43222.01,
            withoutPublift : 32016.30,
            breakpoint : 575,
            
            series: [
              {
                  name: "With Publift",
                  data: breakpoint < window.innerWidth ? [1800.92, 3601.83, 5402.75, 7203.67, 9004.58, 10805.50, 12606.42, 14407.34, 16208.25, 18009.17, 19810.09, 21611.00, 23411.92, 25212.84, 27013.75, 28814.67, 30615.59, 32416.50, 34217.42, 36018.34, 37819.25, 39620.17, 41421.09, 43222.01] : [1800.92, 3601.83, 5402.75, 7203.67, 9004.58, 10805.50]
              },
              {
                  name: "Without Publift",
                  data: breakpoint < window.innerWidth ? [1334.01, 2668.03, 4002.04, 5336.05, 6670.06, 8004.08, 9338.09, 10672.10, 12006.11, 13340.13, 14674.14, 16008.15, 17342.16, 18676.18, 20010.19, 21344.20, 22678.21, 24012.23, 25346.24, 26680.25, 28014.26, 29348.28, 30682.29, 32016.30] : [1334.01, 2668.03, 4002.04, 5336.05, 6670.06, 8004.08]
              }
            ],
            options: {
                chart: {
                    height: 350,
                    type: 'line',
                    toolbar: {
                    show: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    zoom: {
                        enabled: false
                    }
                },
                colors: ['#ff4068', '#7f7b7b'],
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: 'smooth'
                },
                tooltip: {
                    theme: 'dark',
                    x: {
                      formatter: function(value) {
                        return 'Month #' + value
                      }
                    }
                },
                title: {
                    text: '',
                    align: 'left'
                },
                grid: {
                    borderColor: '#7f7b7b',
                    row: {
                    colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 1
                    },
                    xaxis: {
                      lines: {
                          show: true
                      }
                    },   
                    yaxis: {
                        lines: {
                            show: true
                        }
                    },  
                },
                markers: {
                    size: 6,
                    colors: ['#ff4068', '#7f7b7b'],
                    strokeColors: "transparent",
                    strokeWidth: 0,
                    hover:{
                        size: 10
                    }
                },
                xaxis: {
                    categories: breakpoint < window.innerWidth ? ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'] : ['1', '2', '3', '4', '5', '6'],
                    title: false
                },
                yaxis: {
                    title: false,
                    labels: {
                        formatter: function (value) {
                            return "$" + value.toLocaleString();
                        }
                      }
                },
                legend: {
                    show: false
                }
            }        
        };
      }

    componentWillReceiveProps(nextProps){
      if(nextProps.avrNum!==this.props.avrNum || nextProps.AvrCPM!==this.props.AvrCPM || nextProps.AdUnitsPP!==this.props.AdUnitsPP || nextProps.currentAdSet!==this.props.currentAdSet){
        this.setState({
          avrNum: this.props.avrNum,
          AvrCPM: this.props.AvrCPM,
          AdUnitsPP: this.props.AdUnitsPP,
        });
        var WithoutPubArr = [];
        var WithPubArr = [];
        var withPubliftTotal = '';
        var withoutPubliftTotal = '';

        setTimeout(() => {
          
        // console.log(this.props.currentAdSet);

        const numLength = breakpoint < window.innerWidth ? 24 : 6

        for (var i = 1; i <= numLength; i++) {
          WithoutPubArr.push(
            ((this.props.avrNum * this.props.AdUnitsPP) / 1000) *
              this.props.AvrCPM *
              i
          );

          if (this.props.currentAdSet === 1) {
            WithPubArr.push(
              ((this.props.avrNum * this.props.AdUnitsPP) / 1000) *
                this.props.AvrCPM *
                i *
                1.51
            );
          } else {
            WithPubArr.push(
              ((this.props.avrNum * this.props.AdUnitsPP) / 1000) *
                this.props.AvrCPM *
                i *
                1.35
            );
          }
        }

        
        withoutPubliftTotal = ((this.props.avrNum * this.props.AdUnitsPP) / 1000) * this.props.AvrCPM * numLength;
        
        if (this.props.currentAdSet === 1) {
          withPubliftTotal = ((this.props.avrNum * this.props.AdUnitsPP) / 1000) * this.props.AvrCPM * numLength * 1.51;
        } else {
          withPubliftTotal = ((this.props.avrNum * this.props.AdUnitsPP) / 1000) *  this.props.AvrCPM * numLength * 1.35;
        }

        this.setState({
          withPublift : withPubliftTotal,
          withoutPublift : withoutPubliftTotal,
          series: [
            {
              data: WithPubArr,
            },
            {
              data: WithoutPubArr,
            },
          ],
        });

      }, 100);
    }
      
    }
    
    render() {
      // console.log(this.props.avrNum, this.props.AvrCPM, this.props.AdUnitsPP, this.props.currentAdSet);

        const withPub = parseFloat(this.state.withPublift); 
        const withOutPub = parseFloat(this.state.withoutPublift); 
        const differance = withPub - withOutPub;

        return (
          <div className="row">
            <div className="col-xl-6 mb-xl-0 mb-3">
              <p>Total projected revenue for next 2 years <strong>(USD)</strong></p>
        <div className="price">${withOutPub.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</div>
            </div>
            <div className="col-xl-6 mb-xl-0 mb-3">
              <p>
              Total projected revenue for next 2 years with <strong className="text-primary">Publift (USD)</strong>
              </p>
              <div className="price">${withPub.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</div>
            </div>
            <div className="col-sm-12 mt-4">
              <p>
                Your revenue uplift with <strong className="text-primary">Publift (USD)</strong>
              </p>
              <div className="price text-primary">${differance.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</div>
            </div>

            <div className="col-sm-12 mt-4">
              <div className="line_chart">
                <Chart
                  options={this.state.options}
                  series={this.state.series}
                  type="line"
                  height={350}
                />
              </div>
            </div>
          </div>
        );
    }
}

export default LineBar;